import _ from 'lodash';
import React from 'react';
import AppLink from '../AppLink/AppLink';
import { formatUSPhone } from '../../../utility/formatPhone';

interface IPhoneLinkProps {
  phone?: string;
  extension?: string;
}

export default function PhoneLink({ phone, extension }: IPhoneLinkProps) {
  if (_.isEmpty(phone)) {
    return <span>-</span>;
  }
  const formattedPhone = formatUSPhone(phone);
  const ext = extension ? ` ext. ${extension}` : '';

  return (
    <span>
      <AppLink to={`tel:${phone}`}> {formattedPhone}</AppLink>
      {ext && <span>{ext}</span>}
    </span>
  );
}
